import { isRecommendationOrder } from './isRecommendationOrder'

export default isRecommendationOrder
